// src/components/Table.tsx (обновленный)

import React from 'react';

import classNames from 'classnames';

import { IColumnDescriptor } from './types';

interface IGenericTableProps<T> {
  columns: IColumnDescriptor<T>[];
  data: T[];
}

const GenericTable = <T extends Record<string, any>>({ columns, data }: IGenericTableProps<T>) => {
  return (
    <div className="overflow-x-auto rounded-lg font-manrope">
      <table className="min-w-[800px] lg:min-w-full bg-white border-collapse table-fixed w-full">
        {/* Добавлено table-fixed */}
        {/* Шапка таблицы */}
        <thead>
          <tr>
            {columns.map((column, index) => (
              <th
                key={(column.key as string) || index}
                className={classNames('py-3 px-4 text-gray-500 font-medium text-[12px]', {
                  'text-right': column.align === 'right',
                  'text-center': column.align === 'center',
                  'text-left': column.align !== 'center' && column.align !== 'right',
                  'rounded-tl-lg': index === 0 || index === columns.length - 1,
                })}
                style={column.width ? { width: column.width } : {}} // Применяем ширину
              >
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        {/* Тело таблицы */}
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex} className="hover:bg-gray-50 transition-colors duration-150 ease-in-out">
              {columns.map((column, colIndex) => (
                <td
                  key={`${column.key as string}-${rowIndex}`}
                  className={classNames('py-2.5 px-4  text-[16px] truncate font-regular', {
                    'text-right': column.align === 'right',
                    'text-center': column.align === 'center',
                    'text-left': column.align !== 'center' && column.align !== 'right',
                    'bg-[#EBEBEB]': rowIndex % 2 === 0,
                  })}
                  style={column.width ? { width: column.width } : {}} // Применяем ширину к ячейкам
                >
                  {column.render ? column.render(row, column.key) : (row[column.key] ?? '')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GenericTable;
